import { ajax } from "rxjs/ajax";
import { stringify } from "querystringify";
import { Auth } from "@pacificoseguros/tools";
import { env } from "../libs/utils/env";

class Api {
    static getHost = () => env.string(process.env.REACT_APP_BACKEND_URL);

    static getUrl = (url: string, host: string) => {
        return `${host}/${url}`;
    };

    static getHeader = () => ({
        "Content-Type": "application/json",
        Accept: "application/json",
    });

    static getPrivateHeader = () => ({
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: Auth.getAuthorization(),
        "Ocp-Apim-Trace": env.string(process.env.REACT_APP_OCP_APIM_TRACE),
        "Ocp-Apim-Subscription-Key": env.string(
            process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY
        ),
        idTrx: 12345678,
        cltId: 2468,
        nombreAplicacion: "aplicacionTest",
        usuarioAplicacion: "usuarioTest",
        procesoNegocio: "procesoTest",
    });

    static getCustomHeader = (
        customHeader: Record<string, string>,
        isPublicRequest: boolean
    ) => {
        const header = isPublicRequest
            ? Api.getHeader()
            : Api.getPrivateHeader();
        return customHeader || header;
    };

    static getJSON = (
        url: string,
        {
            params = {},
            isPublicRequest = false,
            host = Api.getHost(),
            customHeader = null,
        } = {}
    ) => {
        return ajax.getJSON(
            Api.getUrl(`${url}?${stringify(params)}`, host),
            Api.getCustomHeader(customHeader, isPublicRequest)
        );
    };

    static get = (
        url: string,
        {
            isPublicRequest = false,
            host = Api.getHost(),
            customHeader = null,
        } = {}
    ) => {
        return ajax.get(
            Api.getUrl(url, host),
            Api.getCustomHeader(customHeader, isPublicRequest)
        );
    };

    static post = (
        url: string,
        {
            entity = {},
            isPublicRequest = false,
            host = Api.getHost(),
            customHeader = null,
        } = {}
    ) => {
        return ajax.post(
            Api.getUrl(url, host),
            entity,
            Api.getCustomHeader(customHeader, isPublicRequest)
        );
    };

    static put = (
        url: string,
        {
            entity = {},
            isPublicRequest = false,
            host = Api.getHost(),
            customHeader = null,
        } = {}
    ) => {
        return ajax.put(
            Api.getUrl(url, host),
            entity,
            Api.getCustomHeader(customHeader, isPublicRequest)
        );
    };

    static delete = (
        url: string,
        {
            isPublicRequest = false,
            host = Api.getHost(),
            customHeader = null,
        } = {}
    ) => {
        return ajax.delete(
            Api.getUrl(url, host),
            Api.getCustomHeader(customHeader, isPublicRequest)
        );
    };

    static patch = (
        url: string,
        {
            entity = {},
            isPublicRequest = false,
            host = Api.getHost(),
            customHeader = null,
        } = {}
    ) => {
        return ajax.patch(
            Api.getUrl(url, host),
            entity,
            Api.getCustomHeader(customHeader, isPublicRequest)
        );
    };
}
export default Api;
